<template>
    <div id="loyaltyComponent">
        <div class="loyaltyComponent-inner">
            <div class="wz-row">
                <template v-if="user_id">
                    <div class="customer-info">
                        <div v-if="loadInfo">
                            <div class="info-account" v-if="Object.keys(membership).length">
                                <h3>Hi {{membership.name | formatName}},</h3>
                                <p>Thank you for being a member of our loyalty program and a loyal customer!</p>
                                <p>You've spent <strong>{{ outputWeb1 | formatPrice }}</strong> towards your next voucher -
                                    Another <strong>{{ 2000000 - outputWeb1 | formatPrice}}</strong> to go!</p>
                            </div>
                            <div v-else>
                                <h3>Hi {{$foodbookConfig.user_phone}}</h3>
                                <p>Sorry we did not find your information. Please contact {{$foodbookConfig.hotline}} for assistance</p>
                            </div>
                        </div>
                        <div class="loyalty-vouchers" v-if="membership.payment_amount && membership.point">
                            <h3>Loyalty Vouchers:</h3>
                            <p>You have {{outputWeb2}} dine-in loyalty vouchers! Just ask our waitstaff when you want to spend them..</p>
                            <div class="list-voucher">
                                <div class="voucher-item" v-for="n in outputWeb2" :key="n">
                                    <h3 class="voucher_name">200,000 VND LOYALTY VOUCHER</h3>
                                    <p class="voucher_description">
                                        Valid for dine-in - ask your waitstaff to redeem
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="e-voucher" v-if="vouchers.length > 0">
                            <h3>Other Vouchers:</h3>
                            <p>To redeem: Show the voucher code to your waitstaff. If a voucher is valid for delivery you can also enter the code on our delivery web-page.</p>
                            <div class="list-voucher" v-if="vouchers.length > 0">
                                <div class="voucher-item" v-for="(voucher) in vouchers">
                                    <h3 class="voucher_name">{{voucher.voucher_campaign_name}}</h3>
                                    <p class="voucher_description">Code: {{voucher.voucher_code}}</p>
                                    <p class="voucher_description">Expires: {{voucher.date_end | formatDate}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="order-history">
                        <h3>Your Order History:</h3>
                        <table class="table-history">
                            <thead>
                            <tr>
                                <th>#</th>
                                <th>Receipt number</th>
                                <th>Date</th>
                                <th>Before discount</th>
                                <th>After discount</th>
                                <th>Restaurant</th>
                            </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(value,key) in transactionHistory.sale_logs">
                                    <td data-title="#">{{++key}}</td>
                                    <td data-title="Receipt number">{{value.tran_no}}</td>
                                    <td data-title="Date">{{value.created_at | formatDate}}</td>
                                    <td data-title="Before discount">{{value.bill_amount |
                                        formatPrice}}
                                    </td>
                                    <td data-title="After discount">{{value.total_amount |
                                        formatPrice}}
                                    </td>
                                    <td data-title="Restaurant">{{value.pos_name}}</td>
                                </tr>
                                <tr v-if="!transactionHistory.count">
                                    <td colspan="6" class="empty-data" v-bind:class="{ loading: loading }" data-title="Order History">Currently unavailable - please check with Cashier for transaction history</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'Profile',
        props:{
            mpoint1: {
                type: Number,
                default: 2000000
            },
            mpoint2: {
                type: Number,
                default: 200
            },
        },
        data() {
            return {
                membership: {},
                vouchers: [],
                transactionHistory: [],
                user_id: this.$foodbookConfig.user_phone,
                loading: true,
                loadInfo: false,
                member: {
                    birthday: null,
                    phone: null,
                    name: null,
                    gender: -1,
                    visit: 3,
                },
            };
        },
        filters: {
            filterVouchersActive: function (vouchers) {
                return vouchers.filter(voucher => {
                    //4: OK, 3: hết hạn, 2: đã sử dụng, 1: ko tồn tại
                    return (voucher.status === 4)
                })
            },
            formatDate(date) {
                let d = new Date(date.replace(/\s/, 'T'));
                //return ("0" + d.getDate()).slice(-2) + '/' + ("0" + (d.getMonth() + 1)).slice(-2) + '/' + d.getFullYear();
                return d.toLocaleDateString();
            },
            formatName(name = '') {
                let names = name.split(',',2);
                if(names[1]){
                    return names[1].trim();
                }
                return name;
            }
        },
        created() {
            if (parseInt(this.user_id)) {
                this.getVoucher(this.user_id);
                this.getMembership(this.user_id);
                this.getOrderLog(this.user_id);
            } else {
                this.$toasted.show("The system has not been processed yet. Please try again later..", {
                    position: "top-center",
                    duration: 10000,
                    type: 'error'
                });
            }
        },
        computed: {
            outputWeb1() {
                return this.membership.payment_amount - (Math.floor( this.membership.payment_amount / this.mpoint1) * this.mpoint1);
            },
            outputWeb2() {
                return Math.floor(this.membership.point / this.mpoint2);
            }
        },
        methods: {
            //Lay danh sách voucher của khách hàng
            getVoucher($phone) {
                this.$http.get(this.$foodbookConfig.wpapi + '/member_vouchers', {
                    params: {
                        user_id: $phone
                    }
                }).then(response => {
                    if (!response.body.data) {
                        this.$toasted.show("The system has not been processed yet. Please try again later..", {
                            position: "top-center",
                            duration: 5000,
                            type: 'error'
                        });
                    } else {
                        this.vouchers = this.$options.filters.filterVouchersActive(response.body.data);
                        // console.log(this.vouchers);
                    }
                }, response => {
                    // error callback
                    console.log("Error getVoucher");
                });
            },
            //Lay thông tin khách hàng
            getMembership($phone) {
                this.$http.get(this.$foodbookConfig.wpapi + '/membership_detail', {
                    params: {
                        user_id: $phone
                    }
                }).then(response => {
                    if (!response.body.data) {
                        this.$toasted.show("The system has not been processed yet. Please try again later..", {
                            position: "top-center",
                            duration: 5000,
                            type: 'error'
                        });
                    } else {
                        this.membership = response.body.data;
                        this.loadInfo = true;
                    }
                }, response => {
                    // error callback
                    console.log("Error getMembership");
                });
            },
            // Lấy danh sách đơn đặt hàng
            getOrderLog($phone) {
                this.$http.get(this.$foodbookConfig.wpapi + '/transactions',{
                    params: {
                        pos_parent: this.$foodbookConfig.pos_name,
                        user_id: $phone
                    }
                }).then(response => {
                    if (response.body.error) {
                       /* this.$toasted.show(response.body.error.message, {
                            position: "top-center",
                            duration: 5000,
                            type: 'error'
                        });*/
                        console.log(response.body.error.message);
                    }else{
                        this.loading = false;
                        this.transactionHistory = response.body.data;
                    }
                }, response => {
                    console.log("Error getOrderLog");
                });
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Profile.vue